import { getLoggedInUserId } from "utils/loginPasswordVerification";

export const RECORD_ACCESS_DOWNLOAD_OTP_VERIFIED_KEY =
  "recordAccessDownloadOtpVerified";

export const isDownloadOtpVerified = (userId = getLoggedInUserId()) => {
  if (!userId) return false;

  try {
    const stored = JSON.parse(
      localStorage.getItem(RECORD_ACCESS_DOWNLOAD_OTP_VERIFIED_KEY) || "null",
    );
    return stored?.userId === userId && stored?.otpVerified === true;
  } catch {
    return false;
  }
};

export const markDownloadOtpVerified = (userId = getLoggedInUserId()) => {
  if (!userId) return;

  localStorage.setItem(
    RECORD_ACCESS_DOWNLOAD_OTP_VERIFIED_KEY,
    JSON.stringify({ userId, otpVerified: true }),
  );
};

export const clearDownloadOtpVerification = () => {
  localStorage.removeItem(RECORD_ACCESS_DOWNLOAD_OTP_VERIFIED_KEY);
};
